import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PartnerOrderService, StoreService } from 'app/services';
import { CustomWindow } from 'app/@types';

declare let window: CustomWindow;

@Component({
    selector: 'partner-mart-locations-create-group',
    templateUrl: './partner-mart-locations-create-group.component.html',
    styleUrls: ['./partner-mart-locations-create-group.component.scss'],
    providers: [MessageService]
})
export class PartnerMartLocationsCreateGroupComponent implements OnInit {
    public adminUrl: string = window['adminUrl'];

    @Input()
    public merchantId: number = 0;

    @Input()
    public onSave: () => void = () => { };

    @Input()
    public onHide: () => void = () => { };

    public group: any = {};

    public freeStores: any[] = [{ Id: 0, Name: 'Search here...', disabled: true }];
    public groupStores: any[] = [];

    public selectedStoreId: number = 0;

    constructor(
        private messageService: MessageService,
        private partnerOrderService: PartnerOrderService,
        private storeService: StoreService) {
    }

    ngOnInit(): void {
        this.getPartnerLocations();
    }

    private getPartnerLocations() {
        this.partnerOrderService.getPartnerLocations(this.messageService)
            .then(data => {
                if (!data || !data.Items) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.freeStores = this.freeStores.concat(data.Items);
            });
    }

    public onStoresSelect(): void {
        // Find selected store
        const ind = this.freeStores.findIndex(x => x.Id === this.selectedStoreId);

        if (ind !== -1) {
            // Add selected store to group
            this.groupStores.push(this.freeStores[ind]);

            // Remove selected store from free stores
            this.freeStores.splice(ind, 1);
            this.freeStores = ([] as any[]).concat(this.freeStores);
        }
    }

    public onDeleteGroupStoreClick(storeId: number): void {
        // Find group store
        const ind = this.groupStores.findIndex(x => x.Id === storeId);

        if (ind !== -1) {
            // Add selected store to freeStores
            this.freeStores.push(this.groupStores[ind]);

            // Remove selected store from group stores
            this.groupStores.splice(ind, 1);
            this.groupStores = ([] as any[]).concat(this.groupStores);
        }
    }

    public onSaveClick(): void {
        const dto = {
            Name: this.group.Name,
            StoreIds: this.groupStores.map((x: any) => x.Id)
        };

        this.storeService.createStoreGroup(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.onSave();
            });
    }

    public onSideBarHide(): void {
        this.onHide();
    }
}
